(function() {
'use strict';
  
  angular
    .module('app.myPolls')
    .controller('LeaderboardController', LeaderboardController);
      
  LeaderboardController.$inject = [
    '$log', 
    '$anchorScroll',
    '$injector',
    '$mdDialog', 
    '$scope', 
    '$stateParams', 
    'metrics',
    'PLUGIN',
    'plugins',
    'myPollsService',
    'shell'
  ];
    
  function LeaderboardController(
      $log, 
      $anchorScroll,
      $injector,
      $mdDialog, 
      $scope, 
      $stateParams,
      metrics,
      PLUGIN,
      plugins, 
      myPollsService,
      shell
    ) {
    $log = $log.getInstance('LeaderboardController');
    
    /* jshint validthis: true */
    var vm = this;
    
    vm.collection = null;
    vm.forceShowNames = false;
    vm.getUserName = getUserName;
    vm.isLeaderboardUpdating = false;
    vm.leaderboard = null; 
    vm.showSelectPollsDialog = showSelectPollsDialog;
    vm.subscribers = [];
    vm.updateLeaderboard = updateLeaderboard;
    vm.updateLeaderboardPromise = null;
    
    activate();
    
    function activate() {
      vm.updateLeaderboardPromise = 
        myPollsService.getCollection($stateParams.collectionId)
          .then(setCollection)
          .then(updateSubscribers)
          .then(function() {
            vm.isLeaderboardUpdating = true;
            renderLeaderboard(vm.collection.leaderboard);
            vm.isLeaderboardUpdating = false;
            return metrics.log('leaderboard');
          });
      $anchorScroll('top');
    }
    
    function calculateScoresByPoll(responsesByPoll) {
      var scores = {};
      var pollsById = getPollsById();
      var leaderboardPlugins = _.indexBy(
        plugins.registered(PLUGIN.LEADERBOARD),
        'name'
      );
      _.each(responsesByPoll, function(responses, pollId) {
        var poll = pollsById[pollId];
        var plugin = leaderboardPlugins[poll.type];
        if (!plugin)
          return;
        var calculateScores = $injector.get(plugin.options.factory);
        scores[pollId] = calculateScores(poll, responses);
      });
      return scores;
    }
    
    function getPollsById() {
      return _.indexBy(
        [].concat.apply([], _.pluck(vm.collection.groups, 'polls')),
        '_id'
      );
    }
    
    function getSelectedPollIds(selectedPolls) {
      var pollIds = [];
      _.each(selectedPolls, function(selected, pollId) {
        if (selected)
          pollIds.push(pollId);
      });
      return pollIds;
    }
    
    function getUserName(userId) {
      var user = vm.subscribers[userId];
      return user 
        ? vm.forceShowNames
          ? user.name.first + ' ' + user.name.last
          : (user.name.anonymous === false)
            ? user.name.display || ((user.name.first || '') + ' ' + (user.name.last || '')) 
            : 'Anonymous'
        : 'Unknown responder';
    }
    
    function groupResponsesByPoll(results) {
      var responsesByPoll = {};
      _.each(results, function(result) {
        var responses = responsesByPoll[result.poll] || [];
        responsesByPoll[result.poll] = responses.concat(result.responses);
      });
      return responsesByPoll;
    }
    
    function prepareNewLeadboard(pollIds) {
      var leaderboard = {};
      _.each(pollIds, function(pollId) {
        leaderboard[pollId] = {};
      });
      return leaderboard;
    }
    
    function renderLeaderboard(scoresByPoll) {
      vm.leaderboard = sumScoresByUser(scoresByPoll);
    }
    
    function setCollection(collection) {
      $log.debug('collection = ', collection);
      shell.setTitle('Leaderboard: ' + collection.name);
      shell.setBack('shell.myPolls.collections.viewCollection', $stateParams);
      vm.collection = collection;
    }
    
    function showSelectPollsDialog() {
      return metrics.log('dialog SelectPolls') 
        .then(function() {
          return $mdDialog.show({
            templateUrl: 'app/my-polls/collections/leaderboard-select-polls.html',
            controller: 'LeaderboardSelectPollsController as vm',
            locals: { collection: vm.collection }
          })
        })
        .then(function() { metrics.log('leaderboard select polls'); })
        .then(function() { updateLeaderboard(); })
        // temp fix for https://github.com/angular/material/issues/10369
        .catch(angular.noop);
    }
    
    function storeLeaderboard(scoresByPoll) {
      _.extend(vm.collection.leaderboard, scoresByPoll);
      return myPollsService.updateCollection(vm.collection, 'leaderboard');
    }
    
    function sumScoresByUser(scoresByPoll) {
      var scoresByUser = {};
      _.each(scoresByPoll, function(scores) {
        _.each(scores, function(score, userId) {
          scoresByUser[userId] = scoresByUser[userId] || {
            user: userId,
            score: 0
          };
          scoresByUser[userId].score += score;
        });
      });
      return _.values(scoresByUser);
    }
    
    function updateLeaderboard() {
      var pollIds = _.keys(vm.collection.leaderboard);
      if (pollIds.length < 1)
        return
      var leaderboard = vm.collection.leaderboard; 
      vm.isLeaderboardUpdating = true;
      vm.leaderboard = null;
      vm.updateLeaderboardPromise = myPollsService.getPollResults(pollIds)
        .then(function(results) { 
          metrics.log('leaderboard update'); 
          return results;
        })
        .then(groupResponsesByPoll)
        .then(calculateScoresByPoll)
        .then(function(scoresByPoll) {
          renderLeaderboard(scoresByPoll);
          return storeLeaderboard(scoresByPoll);
        })
        .then(function() {
          vm.isLeaderboardUpdating = false;
        });
      return vm.updateLeaderboardPromise;
    }
    
    function updateSubscribers() {
      return myPollsService.listSubscribers(vm.collection._id)
        .then(function(subscribers) {
          vm.subscribers = _.indexBy(subscribers, '_id');
        });
    }
    
  }
  
})();
